import React from "react";
import { useSelector } from "react-redux";
import { PLACEHODERIMAGE } from "Constants/constants";

//TODO: remove check for show icon onces ui-revamped completes for other modules as well
const CategoryListItem = ({
  category,
  wrapperStyles = {},
  itemStyles = {},
  showIcon,
  scrollOffset = 120,
  iconUrl,
}) => {
  const selectedCategory = useSelector(
    (state) => state?.store?.selectedCategory
  );
  const {brandInfo} = useSelector((state) => state?.brandStorageReducer);

  // Early return if essential values are missing
  if (!category || !category._id || !category.baseLanguage?.name) {
    return null;
  }

  const handleClick = (id) => {
    try {
      const targetEle = document.getElementById(id);
      if (!targetEle) return;

      document
        .querySelectorAll("scroll-checker")
        .forEach((el) => el.setAttribute("data-clicked", id));

      window.scrollTo({
        top: targetEle.getBoundingClientRect().top + window.scrollY - scrollOffset,
        behavior: "smooth",
      });
    } catch (error) {
      console.error("Scroll error:", error);
    }
  };

  const isSelected = selectedCategory === category?._id;

  return showIcon ? (
    <div
      data-key={category?._id}
      className={`flex flex-col justify-center items-center gap-2 p-0 ${wrapperStyles?.className || ""}`}
      style={wrapperStyles?.style || {}}
      onClick={() => handleClick(category?._id)}
    >
       <span
        className={`whitespace-nowrap font-semibold ${
          isSelected
            ? "text-brand-base-primary"
            : ""
        } ${itemStyles?.className || ""}`}
        style={itemStyles?.style || {}}
      >
        {category?.baseLanguage?.name}
      </span>
      <div
        className={`w-20 h-20`}
      >
        <img
          src={iconUrl || brandInfo?.setting?.brandLogoFirst || PLACEHODERIMAGE}
          alt={category?.baseLanguage?.name}
          className="w-full h-full object-contain"
        />
      </div>
     
    </div>
  ) : (
    <span
      data-key={category?._id}
      className={`px-1 ${wrapperStyles?.className || ""}`}
      style={wrapperStyles?.style || {}}
      onClick={() => handleClick(category?._id)}
    >
      <span
        className={`flex whitespace-nowrap items-center h-8 px-4 rounded-full border ${
          isSelected
            ? "text-brand-text-primary bg-brand-base-primary border-brand-base-primary"
            : "border-gray-200"
        } ${itemStyles?.className || ""}`}
        style={itemStyles?.style || {}}
      >
        {category?.baseLanguage?.name}
      </span>
    </span>
  );
};

export default CategoryListItem;
